/* eslint-disable */
import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
let internalToken = null;

export function getToken() {
  return internalToken;
}

export async function getTokenInternal() {
  const url = `${process.env.REACT_APP_API_HOST}/token`;
  try {
    const response = await fetch(url, {
      credentials: "include",
    });
    if (response.ok) {
      const data = await response.json();
      internalToken = data.access_token;
      return data; // Return both token and user data
    }
  } catch (e) {}
  return false;
}

// export async function getTokenInternal() {
//   const url = `${process.env.REACT_APP_API_HOST}/token`;
//   try {
//     const response = await fetch(url, {
//       credentials: "include",
//     });
//     if (response.ok) {
//       const data = await response.json();

//       // Filter out 'question' and 'answer' from data
//       const responseData = { ...data }; // Create a shallow copy of data
//       delete responseData.question;
//       delete responseData.answer;

//       return responseData; // Return modified data object
//     }
//   } catch (e) {
//     console.error("Error fetching token:", e);
//   }
//   return false;
// }


export const AuthContext = createContext({
  user: null, // Include user data in the context
  setUser: () => null,
  token: null,
  setToken: () => null,
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Add user state
  const [token, setToken] = useState(null);

  return (
    <AuthContext.Provider value={{ user, setUser, token, setToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);

export function useToken() {
  const { user, setUser, token, setToken } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchToken() {
      const userData = await getTokenInternal();
      if (userData) {
        setUser(userData.user);
        setToken(userData.token);
      }
    }
    if (!token) {
      fetchToken();
    }
  }, [setUser, setToken, token]);

  async function logout() {
    // if (token) {
      const url = `${process.env.REACT_APP_API_HOST}/token`;
      await fetch(url, { method: "delete", credentials: "include" });
      internalToken = null;
      setUser(null);
      setToken(null);
      navigate("/", { state: { notice: "You have been logged out." } });
    // }
    return {
      "message":"logged out"
    }
  }

async function login(username, password) {
  const url = `${process.env.REACT_APP_API_HOST}/token`;
  const form = new FormData();
  form.append("username", username);
  form.append("password", password);

  try {
    const response = await fetch(url, {
      method: "post",
      credentials: "include",
      body: form,
    });

    if (response.ok) {
      const data = await getTokenInternal();
      setToken(data.access_token);
      setUser(data.user);
    } else {
      throw new Error("Incorrect username or password");
    }
  } catch (error) {
    console.error("Error during login:", error.message);
    throw error; // rethrow the error for the calling function to handle
  }
}

  async function submit(username, password) {
    const url = `${process.env.REACT_APP_API_HOST}/api/accounts`;
    const response = await fetch(url, {
      method: "post",
      body: JSON.stringify({
        username,
        password,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      await login(username, password);
    }
    return false;
  }

  async function update(username, password) {
    const url = `${process.env.REACT_APP_API_HOST}/api/accounts`;
    const response = await fetch(url, {
      method: "patch",
      body: JSON.stringify({
        username,
        password,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      await login(username, password);
    }
    return false;
  }

  async function signup(username, discord_name, visible, question, answer, password, language_id) {
    const url = `${process.env.REACT_APP_API_HOST}/api/accounts`;
    const response = await fetch(url, {
      method: "post",
      body: JSON.stringify({
        username,
        discord_name,
        visible,
        role: "pleb",
        question,
        answer,
        password,
        language_id,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      await login(username, password);
      return true; // success
    } else {
      // const errorData = await response.json();
      const message = "Signup failed";
      throw new Error(message);
    }
  }


  return { token, login, logout, signup, update };
}

